"use client";

import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Harry had the skills from his degree and experience of social media influencing to make a direct impact",
  name: "Michael Sells",
  role: "MANAGER · FLAVEL ARTS CENTRE",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/testimonial_flavel_director.png",
  initials: "SJ"
}, {
  quote: "\n",
  name: "\n",
  role: "\n",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706701/img/testimonial_academic_lead.png",
  initials: "MT"
}];
export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const blocks = document.querySelectorAll<HTMLElement>("[data-voice-block]");
      let current = 0;
      blocks.forEach((block, i) => {
        const rect = block.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.5) {
          current = i;
        }
      });
      setActiveIndex(current);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="21550" id="what-our-partners-say" className="bg-background text-foreground py-32 md:py-44 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1320px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <div className="font-mono text-xs uppercase tracking-[0.18em] text-primary mb-8">
                What Our Partners Say
              </div>

              <h2 className="font-default font-normal text-foreground leading-[1.05] tracking-[-0.02em] mb-8" style={{
              fontSize: "clamp(2rem, 4.5vw, 3.75rem)"
            }}>
                Voices of{" "}
                <span className="italic font-light text-primary">Impact</span>
              </h2>

              <p className="font-default text-muted-foreground leading-[1.6] mb-12" style={{
              fontSize: "clamp(1.05rem, 1.3vw, 1.1875rem)"
            }}>
                Hear from the community leaders, academic partners, and emerging talent who are building sustainable futures through our collaborative model.
              </p>

              <div className="hidden lg:flex items-center gap-4">
                <span className="font-mono text-2xl text-primary tabular-nums">
                  {String(activeIndex + 1).padStart(2, "0")}
                </span>
                <span className="h-px w-12 bg-border" />
                <span className="font-mono text-sm text-muted-foreground tabular-nums">
                  {String(testimonials.length).padStart(2, "0")}
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            {testimonials.map((t, i) => <TestimonialBlock key={i} data-index={i} testimonial={t} isLast={i === testimonials.length - 1} delay={i * 80} />)}
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialBlock({
  testimonial,
  isLast,
  delay,
  ...rest
}: {
  testimonial: {
    quote: string;
    name: string;
    role: string;
    image: string;
    initials: string;
  };
  isLast: boolean;
  delay: number;
  [key: string]: any;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2,
    once: true
  });
  return <div ref={ref} data-voice-block {...rest} style={{
    transitionDelay: `${delay}ms`
  }} className={`py-16 first:pt-0 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="relative">
        {}
        <Quote aria-hidden="true" strokeWidth={1} className="absolute -top-2 right-0 text-primary/40 rotate-180" style={{
        width: "clamp(3rem, 5vw, 4.5rem)",
        height: "clamp(3rem, 5vw, 4.5rem)"
      }} />

        <blockquote className="font-default font-normal text-foreground leading-[1.4] mb-10 pt-16 md:pt-20" style={{
        fontSize: "clamp(1.25rem, 2vw, 1.625rem)"
      }}>
          {testimonial.quote}
        </blockquote>

        <div className="flex items-center gap-4">
          

          <div className="flex flex-col gap-1">
            <span className="font-default font-semibold text-foreground text-base">
              {testimonial.name}
            </span>
            <span className="font-mono text-xs uppercase tracking-[0.12em] text-muted-foreground">
              {testimonial.role}
            </span>
          </div>
        </div>
      </div>

      {!isLast && <Separator className="mt-16 bg-border" />}
    </div>;
}